import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
@Pipe({
    name: 'sanitizedHtml'
})
export class SanitizedHtmlPipe implements PipeTransform {
    private readonly _sanitizer = inject(DomSanitizer);

    transform(value: any): any {
        return this._sanitizer.sanitize(SecurityContext.HTML, value);
    }
}
